import { Fragment } from "react";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import type { ITemplate } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { TemplateContent } from "../../../../components";

export const Template = () => {
  const { data: template, isLoading } = useFetchData<ITemplate>("/templates");

  if (isLoading) {
    return <Spinner />;
  }

  if (!template) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "marketplace", "marketplace.template"]} data={[{}, {}, template]} />

      <PageHeader message="pages.marketplace.template.title" data={template} />

      <TemplateContent template={template} />
    </Fragment>
  );
};
